<!-- Status Indicator Container -->
<div [class]="hostClasses()">
  <!-- Status Indicator Chip (read-only) -->
  <div
    class="hx-status-indicator__chip"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    [hxTooltip]="currentTooltip()"
    position="bottom">
    <!-- Icon comes first -->
    @if (showIcon()) {
      <hx-icon
        class="hx-status-indicator__icon"
        [svgIcon]="isOnline() ? 'record-circle' : 'cloud-slash'"
        [inline]="true"
        aria-hidden="true"></hx-icon>
    }

    <!-- Label after icon -->
    <span class="hx-status-indicator__label">
      {{ currentLabel() }}
    </span>
  </div>
</div>
